<script lang="ts" setup>
// https://dev.to/maxwelladapoe/creating-a-custom-checkbox-component-in-vue-3-a-better-approach-2jjd

const props = withDefaults(
  defineProps<{
    value: string;
    label?: string;
    modelValue: string[];
  }>(),
  {},
);

const emit = defineEmits<{
  (e: "update:modelValue", value: string[]): void;
}>();

const styles = computed(() => ({
  "filter-active": props.modelValue.find((item) => item === props.value),
}));

const model = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>
<template>
  <label class="relative filter" :class="styles">
    <slot>{{ label }}</slot>
    <input
      v-model="model"
      type="checkbox"
      :value="value"
      class="absolute opacity-0"
    />
  </label>
</template>
<style scoped>
.filter:after {
  content: "";
  @apply absolute -inset-1 rounded bg-integer-white opacity-0;
}

.filter:active:after {
  @apply opacity-90;
}
</style>
